<template>
  <CommonLayout header="DeliveryImageSpHeader" footer="ManagementFooter">
    <div class="container">
      <div class="row justify-content-center align-items-top mh-100vh mt-5">
        <div class="col-lg-5 col-md-8">
          <div class="card-group">
            <div class="card p-4">
              <b-overlay :show="overlayShow" rounded="sm">
                <div class="card-body form-row">
                  <h5 class="my-1 col-12 text-center">納品完了・納品画像の登録</h5>
                  <label class="mt-5 col-12 text-center">キー情報を入力してください</label>
                  <div class="my-3 col-8">
                    <input class="form-control" :class="{'is-invalid is-invalid-custom' : validation.hasError('caseNumberLastFourDigit')}" type="text" ref="caseNumberLastFourDigit" v-model="caseNumberLastFourDigit" maxlength="4">
                    <div class="invalid-feedback">{{ validation.firstError('caseNumberLastFourDigit') }}</div>
                  </div>
                  <div class="my-3 col-4">
                      <b-button block class="main-color" @click.stop.prevent="next()">次へ</b-button>
                  </div>
                </div>
              </b-overlay>
            </div>
          </div>
        </div>
      </div>
    </div>
  </CommonLayout>
</template>
<script>
import Vue from 'vue'
import CommonLayout from '@/layout/CommonLayout'
import SimpleVueValidation from 'simple-vue-validator'
import DeliveredImageLoginModel from '@/models/DeliveredImageLoginModel'
const Validator = SimpleVueValidation.Validator

Vue.use(SimpleVueValidation)

export default {
  name: 'DeliveredImageLoginSp',
  components: { CommonLayout },
  data () {
    return {
      overlayShow: false,
      projectNumber: null,
      caseNumberLastFourDigit: ''
    }
  },
  validators: {
    caseNumberLastFourDigit: function (value) {
      return Validator.value(value).required(this.consts.validationMsg.deliveryImageLoginSp.caseNumberLastFourDigit.required)
    }
  },
  methods: {
    next: async function () {
      this.overlayShow = true
      let isError = await this.$validate()
        .then((success) => {
          return !success
        })

      if (isError) {
        this.overlayShow = false
        return false
      }

      try {
        const [projectNumber, token] = this.getProjectNumberAndToken()
        this.projectNumber = projectNumber
        const reqData = {
          projectNumber: this.projectNumber,
          token: token,
          caseNumberLastFourDigit: this.$refs.caseNumberLastFourDigit.value
        }

        const result = await DeliveredImageLoginModel.postApi(this.$bvModal, reqData, () => {
          this.overlayShow = false
        })
        if (result === undefined && result.response === undefined) {
          throw new Error('API error.')
        } else if (result.response && result.response.status !== 200) {
          throw new Error('API error.')
        }

        this.$router.push('/delivered_image_sp/' + this.projectNumber)
      } catch (err) {
        console.log(err)
        this.overlayShow = false
        return false
      }
    },
    getProjectNumberAndToken () {
      if (!this.$route.query.projectNumber) {
        throw new Error('レコード番号がありません')
      }
      if (!this.$route.query.token) {
        throw new Error('トークンがありません')
      }
      return [this.$route.query.projectNumber, this.$route.query.token]
    }
  }
}
</script>
<style>
.tile-image {
  height: 140px;
}
</style>



// WEBPACK FOOTER //
// src/pages/DeliveredImageLoginSp.vue